// extracted by mini-css-extract-plugin
export var img = "FluidModal-module--img--e2758";